import { ProblemDetails } from '@core/models/problem-details.model';

export const DEFAULT_PROBLEM_DETAILS: Readonly<ProblemDetails> = {
  title: 'Unexpected Error',
  status: 500,
  detail: 'An unknown server error occurred.',
  code: 'INTERNAL_SERVER_ERROR',
} as const;
